









































































































































import { Component, Vue } from "vue-property-decorator";
import { reloadScrollBars, unloadScrollBars } from "@/utils/scrollbar";
import NoticeService from "@/services/notice";
import { handlingError } from "@/utils/errorHandling";

@Component({})
export default class product extends Vue {
  reveal = false;
  private isEditing: boolean = false;
  private noticeService = new NoticeService();
  public erfxs: any = [];

  public fetching: boolean = true;
  public processing: boolean = false;
  public msg: string = "Fetching eRFXs...";
  public pagination: any = {
    hasPrev: false,
    hasNext: false
  };

  private name: string = "";
  private description: string = "";
  private searchValue: string = "";
  private isSearching: boolean = false;
  private id: any = null;
  private meta: any = {};

  async mounted() {
    this.fetching = true;
    this.getRFXs();
  }

  private async getRFXs(page?: string) {
    this.msg = "Fetching eRFXs...";
    this.fetching = true;

    await this.noticeService
      .getNoticeAwards(this.searchValue, page)
      .then(
        res => {
          this.erfxs = res.data;
          this.meta = res.meta;
          this.pagination = {
            hasPrev: res.links.prev !== null,
            hasNext: res.links.next !== null
          };
        },
        err =>
          handlingError(err, this, "An error occurred while fetching eRFXs!")
      )
      .finally(() => {
        this.fetching = false;
        this.isSearching = false;
      });
  }

  public goToNext(): void {
    if (!this.pagination.hasNext) {
      return;
    }
    this.getRFXs(`?page=${this.meta.current_page + 1}`);
  }

  public goToPrev(): void {
    if (!this.pagination.hasPrev) {
      return;
    }
    this.getRFXs(`?page=${this.meta.current_page - 1}`);
  }

  public search(e: any): void {
    e.preventDefault();
    this.isSearching = true;
    this.searchValue = this.description;
    this.getRFXs();
  }
}
